import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges } from '@angular/core';
import { AssetCategoryGroupType } from '../../domain/public-api';

@Component({
  selector: 'td-wb-lti-asset-category-group-icon',
  template: '<span class="td-wb-lti-asset-category-icon" [ngClass]="assetCategoryGroupClass"></span>',
  styleUrls: ['asset-category-icon.component.scss'],
  imports: [
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetCategoryGroupIconComponent implements OnChanges {

  private static readonly ASSET_CATEGORY_GROUP_COLOR_CLASS: Map<AssetCategoryGroupType, string> = new Map<AssetCategoryGroupType, string>([
    [AssetCategoryGroupType.EQUITIES, 'td-wb-lti-asset-category-group-equities'],
    [AssetCategoryGroupType.CASH_AND_FIXED_INCOME, 'td-wb-lti-asset-category-group-cash_and_fixed_income']
  ]);

  private static readonly ASSET_CATEGORY_GROUP_MISSING_CLASS: string = 'td-wb-lti-asset-category-group-missing';

  @Input() assetCategoryGroupType: AssetCategoryGroupType;

  assetCategoryGroupClass: string = AssetCategoryGroupIconComponent.ASSET_CATEGORY_GROUP_MISSING_CLASS;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.assetCategoryGroupType.currentValue !== undefined) {
      this.assetCategoryGroupClass = this.getAssetCategoryGroupStyle(changes.assetCategoryGroupType.currentValue);
    }
  }

  private getAssetCategoryGroupStyle(assetCategoryGroupType: AssetCategoryGroupType): string {
    return AssetCategoryGroupIconComponent.ASSET_CATEGORY_GROUP_COLOR_CLASS.get(assetCategoryGroupType);
  }

}
